import { cn } from '../../utils/cn';

/** `$group-*-glow` do `.pen` = cor do grupo a 28% (sufixo hex `47`). */
const GLOW_ALPHA = '47';

/**
 * Espelho React de `ds/feedback/progress-bar` (`g2fuMu`) do `.pen`, na variante
 * «uma cor por grupo/categoria» usada pela família group-card.
 *
 * Alturas lidas do `.pen`:
 *   group    → `ds/card/expense-group--*` › `track` (8)
 *   category → `ds/row/category-progress` › `track` (4)
 *   row      → `ds/row/budget-group-item` / `ds/card/income-source-row` › `track` (3)
 */
const HEIGHTS = {
  group: 'h-2',
  category: 'h-1',
  row: 'h-[3px]',
};

export function GroupProgressTrack({
  percentage,
  color,
  size = 'group',
  gradient = false,
  dimmed = false,
  ariaLabel,
  className,
  ...rest
}) {
  const num = Number(percentage);
  const width = Number.isFinite(num) ? Math.max(0, Math.min(100, num)) : 0;

  return (
    <div
      role="progressbar"
      aria-valuenow={width}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
      className={cn(
        'w-full overflow-hidden rounded-ds-full bg-track',
        HEIGHTS[size] || HEIGHTS.group,
        className,
      )}
      {...rest}
    >
      <div
        className={cn('h-full rounded-ds-full transition-[width]', dimmed && 'opacity-55')}
        style={{
          width: `${width}%`,
          ...(gradient
            ? { backgroundImage: `linear-gradient(to left, ${color}, ${color}${GLOW_ALPHA})` }
            : { backgroundColor: color }),
        }}
      />
    </div>
  );
}
